export default __webpack_public_path__ + "static/media/carmello.df2571ce.webp";